import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MessageDialogComponent } from '../sms-message-dialog/message-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScheduleMessageDialogData } from 'src/app/models/schedule-message-dialog-data.model';

@Component({
  selector: 'app-schedule-message-dialog',
  templateUrl: './schedule-message-dialog.component.html',
  styleUrls: ['./schedule-message-dialog.component.scss'],
})
export class ScheduleMessageDialogComponent implements OnInit {
  form: UntypedFormGroup;
  timezoneConfig = {
    hideSelected: false,
    dropdownPosition: 'top',
    appearance: 'underline',
    clearOnBackspace: true,
    closeOnSelect: true,
    appendTo: null,
  };
  hours: string[] = this.generateHours();

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScheduleMessageDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      selectedDate: [null, Validators.required],
      selectedHour: [null, Validators.required],
      timezone: [this.data?.defaultTimezone ?? null, Validators.required],
    });
  }

  save(): void {
    const { selectedDate, selectedHour, timezone } = this.form.value;
    const dateOnly = moment.utc(selectedDate).format('YYYY-MM-DD');
    const [hours, minutes] = selectedHour.split(':').map((v: string) => parseInt(v, 10));
    const combinedDate = moment
      .tz(dateOnly, timezone.nameValue)
      .hours(hours)
      .minutes(minutes)
      .seconds(0)
      .milliseconds(0);
    const utc = combinedDate.utc();
    const formattedDate = utc.format('MM/DD/YY hh:mm A z');
    this.dialogRef.close({
      sendTime: formattedDate,
      timezone,
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  private generateHours(): string[] {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        times.push(time);
      }
    }
    return times;
  }
}
